import { ref, type Ref } from 'vue';
import { persistResumable } from '@/stores';

// Filled on first use: @/stores imports the flow store, which imports this module, so
// calling persistResumable during evaluation would read it before @/stores is initialised.
let isResumable: Ref<boolean> | undefined;
let lastKnownTotal: Ref<string> | undefined;

export function useResumableReservation() {
	const resumable = (isResumable ??= ref(persistResumable('flow/resumable', false)));
	const total = (lastKnownTotal ??= ref(persistResumable('flow/total-price', '')));

	return {
		isResumable: resumable,
		lastKnownTotal: total,

		markResumable: () => {
			resumable.value = true;
		},

		rememberTotal: (newTotal: string | undefined | null) => {
			total.value = newTotal ?? '';
		},

		forget: () => {
			resumable.value = false;
			total.value = '';
		},
	};
}
